// extracted by mini-css-extract-plugin
module.exports = {"graph":"MonthCard_graph__SxsI5","grid":"MonthCard_grid__nl_TK","data":"MonthCard_data__eh4b3","legend":"MonthCard_legend__6AY_d","item":"MonthCard_item__fkXI3"};